define('tdnoticelist', ['jquery', 'waajax', 'wanotifications', 'wamessages'], function ($, waajax, wanotifications, wamessages) {

  return {
    noticeButtons: $('.product__noticelist--link[data-request]'),
    headerCircle: $('.navigation__circle.favourite'),
    loginStatus: $('html').hasClass('logged-in'),
    loginBoxTrigger: $('[data-modal-open="js_loginbox"]'),
    onListAttr: "onlist",
    successClassName: "red",
    visibleClassName: "visible",
    itemCountCircle: $('.navigation__circle.favourite, .navigation__box .sidebar__favourite'),
    keyName: 'triggerNoticeList',

    bindEvents: function bindEvents() {
      var _this = this;

      this.noticeButtons.on('click', function (e) {
        _this.sessionTrigger('del');

        _this.currentTarget = $(e.currentTarget);
        _this.currentHeart = _this.currentTarget.find('i').eq(0);
        _this.requestUri = _this.currentTarget.data('request');

        e.preventDefault();
        e.stopPropagation();

        if (!!_this.checkUserLoginStaus()) {
          !!_this.checkNoticeStatus() ? _this.removeFromNoticeList() : _this.setToNoticeList();
        } else {
          _this.sessionTrigger('set', _this.currentAid);
          _this.setUserLoginMessage();
        }
        return false;
      });
    },
    sessionTrigger: function sessionTrigger(status, currentAid) {
      if (status === 'set') {
        return sessionStorage.setItem(this.keyName, currentAid);
      } else if (status === 'get') {
        return sessionStorage.getItem(this.keyName);
      } else if (status === 'del') {
        return sessionStorage.removeItem(this.keyName);
      }
    },
    triggerNoticeList: function triggerNoticeList() {
      if (!!this.sessionTrigger('get')) {
        var currentAid = this.sessionTrigger('get');
        $('form[data-aid="' + currentAid + '"]').parent().trigger('click') && this.sessionTrigger('del');
      }
    },
    checkUserLoginStaus: function checkUserLoginStaus() {
      return this.loginStatus;
    },
    setUserLoginMessage: function setUserLoginMessage() {
      if (!!this.loginBoxTrigger) this.loginBoxTrigger.trigger('click');
    },
    checkNoticeStatus: function checkNoticeStatus() {
      return this.currentTarget.attr('data-' + this.onListAttr);
    },
    setUserMsg: function setUserMsg(msgKey) {
      wanotifications.msg(wamessages[wamessages.actLang][msgKey], 'success');
      return true;
    },
    updateCountNoticeItems: function updateCountNoticeItems() {

      this.currentItems !== 0 ? this.itemCountCircle.addClass(this.visibleClassName) : this.itemCountCircle.removeClass(this.visibleClassName);
      this.itemCountCircle.html(this.currentItems).show();
    },
    setToNoticeList: function setToNoticeList(requestUri) {
      var _this2 = this;

      this.currentHeart.addClass(this.successClassName);
      waajax.ajax(this.requestUri, {}, '', function (response) {
        if (!!response) {
          _this2.currentTarget.attr('data-' + _this2.onListAttr, '1');
        }
      });
    },
    removeFromNoticeList: function removeFromNoticeList() {
      location.href = this.currentTarget.data('request');
    },
    init: function init() {
      this.bindEvents();
      this.triggerNoticeList();
    }
  };
});

